import { render, staticRenderFns } from "./contentEditProfile.vue?vue&type=template&id=4a5ac942&"
import script from "./contentEditProfile.vue?vue&type=script&lang=js&"
export * from "./contentEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports